import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class Country extends ModelPrototype {
  public async list(): Promise<any> {
    try {
      return this.withUrl(`location/country/list`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
